import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import moment from 'moment';
import esLocale from 'moment/locale/es';
import ptLocale from 'moment/locale/pt';
import PropTypes from 'prop-types';

import LoaderWithLogo from '../LoaderWithLogo';
import PermissionDenied from '../PermissionDenied';
import { getAppConfig } from '../utilities';
import { usePermissions } from './customHook/usePermissions';

const HeaderInjector = props => {
  const params = useParams();
  const { pathname } = useLocation();
  const { RenderedComponent, roles, children, allRuleCheck = false } = props;

  useEffect(() => {
    const { lang } = getAppConfig('locale');
    moment.locale(lang, [esLocale, ptLocale]);
  }, []);

  const { loading, hasAccess } = usePermissions(roles, allRuleCheck);

  if (loading) {
    return <LoaderWithLogo />;
  }

  if (!hasAccess) {
    return <PermissionDenied />;
  }

  return (
    <>
      {React.isValidElement(children) && children}
      <RenderedComponent {...props} match={{ params, path: pathname, url: pathname }} RenderedComponent={null} />;
    </>
  );
};

HeaderInjector.propTypes = {
  RenderedComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  roles: PropTypes.instanceOf(Array),
  children: PropTypes.oneOfType([PropTypes.node]),
  allRuleCheck: PropTypes.bool
};

HeaderInjector.defaultProps = {
  roles: [],
  children: null,
  allRuleCheck: false
};

export default HeaderInjector;
